import React from 'react';
import Navbar from '../Navbar'; 
import BrandForm from '../brand/BrandForm';

function BrandPage() {
    return (
        <>
            <Navbar />
            <BrandForm />
        </>
    );
}

export default BrandPage;
